const passwordValidationRegex =
  '^(?=(.*\\d){2})(?=.*[a-zA-z]){1,}[0-9a-zA-Z!@#$%^&*()\\-_=+{}|?>.<,:;~`’]{8,30}$';

const emailValidationRegex =
  '^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$';

const commaSeparatedStringNoSpaces = /^[^,\s]+(,[^,\s]+)*$/;

const CommonRegex = {
  passwordValidationRegex,
  emailValidationRegex,
  commaSeparatedStringNoSpaces,
};

export default CommonRegex;
